import ru from "element-ui/lib/locale/lang/ru-RU";
import en from "element-ui/lib/locale/lang/en";
import it from "element-ui/lib/locale/lang/it";
import locale from 'element-ui/lib/locale';

export default {
    created() {
        switch(window.laravel.locale) {
            case 'en':
                locale.use(en);
                break;
            case 'it':
                locale.use(it);
                break;
            case 'ru':
            default:
                locale.use(ru);
        }
    }
}
